import type { PersonalSpaceView } from '@/features/personal-space/types';
import { apiFetch } from '@/lib/api/client';

/**
 * Personal Memorization Space (ADR-031). Deliberately NOT tenant-scoped:
 * the caller may hold no organization membership at all, which is exactly
 * the state these two calls exist to resolve - sending an
 * `X-Organization-Id` header here would be sending an organization the
 * caller does not yet have.
 */

/** `GET /personal-space`. Returns null when the caller has no personal space yet. */
export async function getPersonalSpace(): Promise<PersonalSpaceView | null> {
  return apiFetch<PersonalSpaceView | null>('/personal-space');
}

/** `POST /personal-space`. Idempotent - a second call returns the existing space. */
export async function createPersonalSpace(): Promise<PersonalSpaceView> {
  return apiFetch<PersonalSpaceView>('/personal-space', { method: 'POST' });
}
